import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import ChessImg from "../../assets/games-images/offline/chess.jpg";

const chess = {
  image: ChessImg,
  description:
    "Calling all masterminds and strategic thinkers! It's time to showcase your skills and dominate the chessboard in our epic Chess tournament. With each move, you'll be testing your opponent's wit and cunning while challenging your own.",
  type: "Online Games",
  eventName: "Chess",
  dateTime: "Feb 26, 6PM-9PM",
  venue: "Online",
  rules: [
    "Platform: Chess.com (Web or App version).",
    "Game Mode: Live game between registered players.",
    "Time Control: 10 minutes per player (no increment).",
    "Format:",
    "  - Swiss system: Players are paired in each round based on their current score.",
    "  - In each round, players will be paired with others who have the same or similar scores.",
    "  - Players will not play against the same opponent more than once.",
    "Fair Play: Players must adhere to the fair play policy. Use of any external assistance will result in disqualification."
],

  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Sugithan",
      phoneNo: "8438732387",
    },
    {
      name: "Parthasarathy",
      phoneNo: "6382993315",
    },
  ],
};

const Chess = () => {
  return (
    <SingleEventPage
      eventDetails={chess}
      formsLink={"https://docs.google.com/forms/d/e/1FAIpQLScqmF3z5EoH1voQLNCbMEu_pWc3YVLQIg6ULQ3FgpO35FSMPQ/viewform?usp=dialog"}
    />
  );
};

export default Chess;
